import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { HolidayRequestStatus } from "@enums/holdayRequestStatus.enum";
import { HolidayTime } from "@enums/holidayTime.enum";
import { PromiseDepartment } from "@enums/promiseDepartment.enum";
import { PromiseType } from "@enums/promiseType.enum";
import { Shift } from "@enums/shift.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Dashboard } from "@interfaces/dashboard.interface";
import { HolidayRequest } from "@interfaces/holidayRequest.interface";
import { Promise } from "@interfaces/promise.interface";
import { SalesEnquiry } from "@interfaces/models/salesEnquiry.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { WorkloadLog } from "@interfaces/workloadLog.interface";
import { WorkloadLogDashboardDto } from "@interfaces/workloadLogDashboardDto.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { DashboardService } from "@services/dashboard.service";
import { HolidayRequestService } from "@services/holidayRequest.service";
import { PromiseService } from "@services/promise.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { SalesEnquiryService } from "@services/salesEnquiry.service";
import { UserProfileService } from "@services/userProfile.service";
import { WorkloadLogService } from "@services/workloadLog.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "dashboard",
	styleUrls: ["dashboard.css"],
	templateUrl: "dashboard.html",
})

export class DashboardAdminComponent {
	dashboards: Dashboard[] = [];
	dataHealth: any[] = [];
	dayShiftHolidayRequests: HolidayRequest[] = [];
	filterPromiseDepartment?: PromiseDepartment;
	filterSalesPromiseDepartment?: PromiseDepartment;
	financial: any;
	financialDashboardMode = "Financials";
	goodsInDashboard: any[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	holidayRequestStatuses: any;
	holidayRequests: HolidayRequest[] = [];
	holidayTimes: any;
	mode = "";
	myBreakdown = [
		{ amount: 0, type: "approved" },
		{ amount: 0, type: "assigned" },
		{ amount: 0, type: "submitted" },
	];
	mySummary: SalesEnquiry[] = [];
	nightShiftHolidayRequests: HolidayRequest[] = [];
	people: UserProfile[] = [];
	popupAddButtonOptions: any;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close", };
	popupPromise: Promise = new Promise();
	popupTitle = "";
	popupVisible = false;
	productionForecast: any;
	promiseBoard: any[] = [];
	promiseDepartments: any;
	promiseTypes: any;
	quotesSent = 0;
	quotesWaitingApproval = 0;
	salesPromiseBoard: any[] = [];
	siteColours: { colour: string, site: string; }[] = [];
	staffAttendance: any;
	thirtyDayValue = 0;
	title = "Dashboard";
	today = "";
	workloadLogAssignableUsers: UserProfile[] = [];
	workloadLogDashboard: WorkloadLogDashboardDto[] = [];
	workloadLogNew: any;
	workloadLogsUser: any[] = [];

	constructor(
		private router: Router,
		private toastService: ToastService,
		private appSettingsService: AppSettingsService,
		private dashboardService: DashboardService,
		private holidayRequestService: HolidayRequestService,
		private promiseService: PromiseService,
		private purchaseLogService: PurchaseLogService,
		private userProfileService: UserProfileService,
		private salesEnquiryService: SalesEnquiryService,
		private workloadLogService: WorkloadLogService
	) {
		this.viewInvoiceRow = this.viewInvoiceRow.bind(this);
		this.viewPurchaseLogRow = this.viewPurchaseLogRow.bind(this);
		this.viewSalesEnquiryRow = this.viewSalesEnquiryRow.bind(this);
		this.getDashboards();
		this.holidayRequestStatuses = GetPropertiesFromEnum(HolidayRequestStatus);
		this.holidayTimes = GetPropertiesFromEnum(HolidayTime);
		this.promiseDepartments = GetPropertiesFromEnum(PromiseDepartment);
		this.promiseTypes = GetPropertiesFromEnum(PromiseType);
		this.promiseTypes.splice(2, 1);
		this.getSupervised();
		this.getWorkload();
		const today = new Date();
		this.today = today.toLocaleDateString("en-GB");
	}

	addNewPromise() {
		this.promiseService.createSingle(this.popupPromise).subscribe(
			() => {
				this.popupVisible = false;
				this.popupPromise = new Promise();
				if (this.mode === "Sales") {
					this.getSalesPromiseBoard();
				}
				else {
					this.getPromiseBoard();
				}

				this.toastService.success("Promise Created");
			},
			(err: any) => {
				this.toastService.error("Something Went Wrong!");
				console.log(err);
			}
		);

		this.closePopup();
	}

	addNewPromisePopup() {
		this.popupPromise = new Promise();
		if (this.mode === "Sales") {
			this.popupPromise.promiseType = PromiseType.Sales;
		}
		this.popupTitle = "Add New Promise";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewPromise(), text: "Add Promise", };
	}

	addNewWorkloadLog() {
		this.workloadLogService.createSingle(this.workloadLogNew).subscribe(
			() => {
				this.popupVisible = false;
				this.workloadLogNew = new WorkloadLog();
				this.getWorkload();
				this.toastService.success("Log Created");
			},
			(err: any) => {
				this.toastService.error("Something Went Wrong!");
				console.log(err);
			}
		);

		this.closePopup();
	}

	addNewWorkloadLogPopup() {
		this.workloadLogNew = new WorkloadLog();
		this.popupTitle = "New Workload Log";
		this.popupVisible = true;
		this.popupAddButtonOptions = {
			onClick: () => this.addNewWorkloadLog(),
			text: "Add Log",
		};
	}

	boolYesNo(bool: boolean) {
		return bool === true ? "YES" : "NO";
	}

	checkOverDue(e: any) {
		const dateToCheck = new Date(e);
		const today = new Date();
		if (today >= dateToCheck) {
			return true;
		} else {
			return false;
		}
	}

	closePopup() {
		this.popupVisible = false;
		this.popupPromise = new Promise();
	}

	deletePromise(e: any) {
		if (confirm("Are you sure you wisth to delete this promise? This can't be undone.") == false) {
			return;
		}
		this.promiseService.deleteSingleById(e.id).subscribe(
			() => {
				if (this.mode === "Sales") {
					this.getSalesPromiseBoard();
				} else {
					this.getPromiseBoard();
				}

				this.toastService.success("Promise Deleted");
			},
			(err: any) => {
				this.toastService.error("Something Went Wrong!");
				console.log(err);
			}
		);
	}

	departmentFilterChanged(args: any) {
		this.filterPromiseDepartment = args.value;

		this.getPromiseBoard();
	}

	downloadProductionForecastCSV() {
		this.dashboardService.productionForecastCSV().subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", "ProductionForecast.csv");
				document.body.appendChild(downloadLink);
				downloadLink.click();
				this.closePopup();
			}
		);
	}

	editPromise() {
		this.promiseService.updateSingleById(this.popupPromise.id, this.popupPromise)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupPromise = new Promise();
					if (this.mode === "Sales") {
						this.getSalesPromiseBoard();
					} else {
						this.getPromiseBoard();
					}
					this.toastService.success("Promise Updated");
				},
				(err: any) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);

		this.closePopup();
	}

	editPromisePopup(e: any) {
		this.popupPromise = new Promise(e);
		this.popupTitle = "Edit Promise";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editPromise(), text: "Save Changes", };
		return false;
	}

	financialDashboardShowFinancials() {
		this.financialDashboardMode = "Financials";
		this.getFinancialDashboard();
	}

	financialDashboardShowProductionForecast() {
		this.financialDashboardMode = "Production Forecast";
		this.getProductionForecastDashboard();
	}

	formatCurrency(amount: number) {
		return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	formatTime(time: Date | string | number | null | undefined): string {
		if (!time) {
			return "";
		}

		const newTime = new Date(time);
		if (isNaN(newTime.getTime())) {
			return "";
		}

		const hours = newTime.getHours().toString().padStart(2, "0");
		const minutes = newTime.getMinutes().toString().padStart(2, "0");

		return `${hours}:${minutes}`; // e.g. "08:12"
	}


	getDashboards() {
		this.headerPrimaryButtons = [
			{ method: "Promises", text: "Promises" },
			{ method: "Goods In", text: "Goods In" },
		];

		this.dashboardService.getForCurrentUser().subscribe(
			(res: any) => {
				this.dashboards = res.response;

				this.dashboards.forEach((dashboard) => {
					this.headerPrimaryButtons.push({
						method: dashboard.name,
						text: dashboard.name,
					});
				});

				// Default Mode
				const defaultMode = this.appSettingsService.get("dashboard", "Promises");
				if (this.headerPrimaryButtons.findIndex((h) => h.text === defaultMode) > -1) {
					this.setMode(defaultMode);
				} else {
					this.setMode("Promises");
				}
			},
			(err) => console.log(err)
		);
	}

	getDataHealthDashboard() {
		this.dashboardService.dataHealth().subscribe(
			(res: any) => (this.dataHealth = res.response),
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getFinancialDashboard() {
		this.dashboardService.financial().subscribe(
			(res: any) => (this.financial = res.response),
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getGoodsInDashboard() {
		this.purchaseLogService.goodsInDashboard().subscribe(
			(res: any) => {
				this.goodsInDashboard = res.response;

				this.goodsInDashboard.forEach(week => {
					week.columns.forEach((day: any) => {
						day.purchaseLogs.forEach((purchaseLog: any) => {
							const site = purchaseLog.site;
							const siteColour = purchaseLog.siteColour;

							if (this.siteColours.filter(s => s.site === site).length < 1) {
								this.siteColours.push({ colour: siteColour, site: site });
							}
						});
					});
				});
				this.siteColours.sort((a, b) => a.site.localeCompare(b.site));
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getPeople() {
		this.userProfileService.getActiveUsers().subscribe(
			(res: any) => {
				this.people = res.response;
				this.people.sort((a, b) =>
					a.fullName.localeCompare(b.fullName)
				);
			},
			(err) => console.log(err)
		);
	}

	getProductionForecastDashboard() {
		this.dashboardService.productionForecast().subscribe(
			(res: any) => (this.productionForecast = res.response),
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getPromiseBoard() {
		if (this.filterPromiseDepartment !== undefined && this.filterPromiseDepartment !== null) {
			this.promiseService.getPromiseBoardForDepartment(this.filterPromiseDepartment).subscribe(
				(res: any) => (this.promiseBoard = res.response),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);

			return;
		}

		this.promiseService.getPromiseBoard().subscribe(
			(res: any) => (this.promiseBoard = res.response),
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getSalesDashboardData() {
		this.salesEnquiryService.myBreakdown().subscribe(
			(res: any) => (this.myBreakdown = res.response),
			(err) => console.log(err)
		);
		this.salesEnquiryService.mySummary().subscribe(
			(res: any) => (this.mySummary = res.response),
			(err) => console.log(err)
		);
		this.salesEnquiryService.quotesSent().subscribe(
			(res: any) => (this.quotesSent = res.response),
			(err) => console.log(err)
		);
		this.salesEnquiryService.quotesWaitingApproval().subscribe(
			(res: any) => (this.quotesWaitingApproval = res.response),
			(err) => console.log(err)
		);
		this.salesEnquiryService.thirtyDayValue().subscribe(
			(res: any) => (this.thirtyDayValue = res.response),
			(err) => console.log(err)
		);
	}

	getSalesPromiseBoard() {
		if (this.filterSalesPromiseDepartment !== undefined && this.filterSalesPromiseDepartment !== null) {
			this.promiseService.getSalesPromiseBoardForDepartment(this.filterSalesPromiseDepartment).subscribe(
				(res: any) => (this.salesPromiseBoard = res.response),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);

			return;
		}

		this.promiseService.getSalesPromiseBoard().subscribe(
			(res: any) => (this.salesPromiseBoard = res.response),
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getStaffDashboardData() {
		this.getPeople();

		this.holidayRequestService.dashboard().subscribe(
			(res: any) => {
				this.holidayRequests = res.response;
				this.dayShiftHolidayRequests = this.holidayRequests.filter(
					(hr) => hr.requestedBy.shiftId === Shift.Day
				);
				this.nightShiftHolidayRequests = this.holidayRequests.filter(
					(hr) => hr.requestedBy.shiftId === Shift.Night
				);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);

		this.dashboardService.staffAttendance().subscribe(
			(res: any) => {
				this.staffAttendance = res.response;
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	getSupervised() {
		this.userProfileService.getUsersSupervisedByMe().subscribe(
			(res: any) => {
				this.workloadLogAssignableUsers = res.response;
			},
			(err) => console.log(err)
		);
	}

	getWorkload() {
		// get workload for the current user.
		this.workloadLogService.myWorkload().subscribe(
			(res: any) => {
				this.workloadLogsUser = res.response;
			},
			(err) => console.log(err)
		);
	}

	getWorkloadDashboard() {
		//get the workload dashboard
		this.workloadLogService.dashboard().subscribe(
			(res: any) => {
				this.workloadLogDashboard = res.response;
				this.workloadLogDashboard.sort((a, b) =>
					a.site.localeCompare(b.site)
				);
			},
			(err) => console.log(err)
		);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) {

			// @ts-ignore
			this[method]();
		} else {
			this.setMode(method);
		}
	}

	healthLabelText(arg: any) {
		return `${arg.valueText} %`;
	}

	nudge(id: number) {
		this.workloadLogService.nudge(id).subscribe(
			() => {
				this.toastService.success("Nudge sent!");
			},
			(err: any) => {
				this.toastService.error("Something Went Wrong!");
				console.log(err);
			}
		);
	}

	printFireRoll(site: any) {
		const clockedIn = (site.userProfiles || []).filter((u: any) => u.inActiveSession);
		const logoUrl = window.location.origin + "/assets/full-logo.jpg";

		const rows = clockedIn.map((u: any) => {
			const time = u.clockedInTime
				? new Date(u.clockedInTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
				: "-";
			return `<tr>
				<td>${u.name}</td>
				<td>${time}</td>
				<td></td>
			</tr>`;
		}).join("");

		const html = `<!DOCTYPE html>
<html>
<head>
	<meta charset="utf-8" />
	<title>Fire Roll Call — ${site.name}</title>
	<style>
		body { font-family: Arial, sans-serif; padding: 24px; color: #111; }
		.header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 20px; }
		.header img { height: 48px; }
		h1 { font-size: 1.25rem; margin: 0 0 4px 0; }
		p.meta { font-size: 0.85rem; color: #555; margin: 0; }
		table { width: 100%; border-collapse: collapse; }
		th { text-align: left; border-bottom: 2px solid #111; padding: 8px 12px; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.05em; }
		td { padding: 10px 12px; border-bottom: 1px solid #ddd; font-size: 0.9rem; }
		td:last-child { width: 80px; }
		@media print { body { padding: 0; } }
	</style>
</head>
<body>
	<div class="header">
		<div>
			<h1>Fire Roll Call — ${site.name}</h1>
			<p class="meta">Printed: ${new Date().toLocaleString()}</p>
		</div>
		<img src="${logoUrl}" alt="BPL Logo" />
	</div>
	<table>
		<thead>
			<tr>
				<th>Person</th>
				<th>Last Clock In</th>
				<th>Present</th>
			</tr>
		</thead>
		<tbody>
			${rows || "<tr><td colspan=\"3\">No staff currently clocked in.</td></tr>"}
		</tbody>
	</table>
</body>
</html>`;

		const win = window.open("", "_blank");
		if (win) {
			win.document.write(html);
			win.document.close();
			win.focus();
			win.print();
		}
	}

	renderRingColour(percentage: number) {
		if (percentage >= 85) {
			return "green";
		} else if (percentage >= 50 && percentage < 85) {
			return "yellow";
		} else {
			return "red";
		}
	}

	renderRingStatus(percentage: number) {
		if (percentage >= 85) {
			return "Excellent";
		} else if (percentage >= 50 && percentage < 85) {
			return "Moderate";
		} else {
			return "Poor";
		}
	}

	renderWorkloadColours(site: string) {
		switch (site) {
			case "KN":
				return "#DAF2D0";
			case "SO":
				return "#F7C7AC";
			case "R":
				return "#dffefe";
			default:
				return "#DAF2D0";
		}
	}

	renderWorkloadColoursHeader(site: string) {
		switch (site) {
			case "KN":
				return "#abe194";
			case "SO":
				return "#f09866";
			case "R":
				return "#98fefe";
			default:
				return "#abe194";
		}
	}

	salesDepartmentFilterChanged(args: any) {
		this.filterSalesPromiseDepartment = args.value;

		this.getSalesPromiseBoard();
	}

	setMode(mode: string) {
		this.mode = mode;
		this.title = `${mode} Dashboard`;
		this.appSettingsService.set("dashboard", mode);
		this.headerSecondaryButtons = [];

		// Fetch data relevant to the mode here
		switch (mode) {
			case "Data Health":
				this.getDataHealthDashboard();
				break;
			case "Financial":
				this.financialDashboardMode = "Financials";
				this.getFinancialDashboard();
				this.headerSecondaryButtons.push({ icon: "fal fa-eye", method: "financialDashboardShowFinancials", text: "Show Financials", });
				this.headerSecondaryButtons.push({ icon: "fal fa-eye", method: "financialDashboardShowProductionForecast", text: "Show Production Forecast", });
				this.headerSecondaryButtons.push({ icon: "fal fa-download", method: "downloadProductionForecastCSV", text: "Production Forecast CSV", });
				break;
			case "Goods In":
				this.getGoodsInDashboard();
				break;
			case "Promises":
				this.headerSecondaryButtons.push({ icon: "fal fa-plus", method: "addNewPromisePopup", text: "New Promise", });
				this.headerSecondaryButtons.push({ icon: "fal fa-eye", method: "viewWorkloadLogs", text: "View Workload", });
				this.headerSecondaryButtons.push({ icon: "fal fa-plus", method: "addNewWorkloadLogPopup", text: "New Workload Log", });
				this.getPromiseBoard();
				break;
			case "Sales":
				this.headerSecondaryButtons.push({ icon: "fal fa-plus", method: "addNewPromisePopup", text: "New Promise", });
				this.getSalesPromiseBoard();
				break;
			case "Staff":
				this.getStaffDashboardData();
				break;
			case "Workload":
				this.getWorkloadDashboard();
				break;
		}
	}

	viewInvoiceRow(e: any) {
		this.router.navigate([`/admin/invoices/${e.row.data.lookupId}`]);
	}

	viewPurchaseLogRow(e: any) {
		this.router.navigate([`/admin/purchaseLogs/${e.row.data.lookupId}`]);
	}

	viewSalesEnquiryRow(e: any) {
		this.router.navigate([`/admin/salesEnquiries/${e.row.data.id}`]);
	}

	viewWorkloadLogs() {
		this.popupTitle = "My Workload Logs";
		this.popupVisible = true;
	}
}
